import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const setConversationsAsSeen = async (selectedDomain: string, conversationId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `conversation/seen`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: { cid: conversationId },
        domain: selectedDomain,
        isEncrypted: true,
    });
}